import { useEffect, useMemo } from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import { useDispatch } from "react-redux";
import { formatTimeSpanToString } from "../../utils/functions";
import { stateSlice } from "../../redux";
import useDataLoader2 from '../../hooks/useDataLoader2';
import { UseCountryList } from "../../hooks/Catalogs";
import { UseRegionList } from "../../hooks/Catalogs/useRegionListOptions";
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from "../../components/Catalogs/Filters/Filters";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const State = () => {
  const dispatch = useDispatch()
  const {countryData} = UseCountryList();
  const {regionData} = UseRegionList();
  const fields = [
    'id', 
    'legacyId', 
    'name',
    'abbreviation',
    'country',
    'regions',
    'countryName',
    'regionNames',
    'hasSubstate',
    'createdDate'
  ]
  const endpoint = '/state';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });
  const columnsDef = useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: "Name" },
    { id: 'abbreviation', header: "Abbreviation" },
    { id: 'country', header: "Country" },
    { id: 'regions', header: "Regions" },
    { id: 'hasSubstate', header: "Has Substate" },
    { id: 'createdDate', header: "Created Date" },
    {
      id: 'edit', 
      header: 'Edit', 
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink 
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      )
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  useEffect(() => {
    dispatch(stateSlice.actions.InitializeState());
  }, []);

  const formatData = (data: any[]) => {
    const formatedData = data.map((d: any) => {
      return {
        ...d,
        country: d.countryName,
        hasSubstate: d.hasSubstate ? "YES" : "NO",
        regions: d.regionNames,
        createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : ''
      }
    })
    return formatedData
  }
  
  const filtersData: IFilterData[] = useMemo(() => [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Abbreviation",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Country", 
      objectData: countryData?.map(c => ({id: c.id, name: c.name})) || [],
    },
    {
      name: "Region",
      fieldName: "regions",
      objectData: regionData?.map(r => ({id: r.id, name: r.name})) || [],
    },
  ], [regionData, countryData]);

  return (
    <>
        <CatalogTableC
          title="State Catalog"
          catalogName="STATES"
          catalogShortName="STATE"
          route="State"
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default State;
